import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PrimaryButtom from "../../../components/buttons/PrimaryButton";

export default function CibilDialog({
  open,
  cibilScoreInput,
  setCibilScoreInput,
  cibilError,
  setCibilError,
  minCIBIL,
  onSubmit,
}) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          bgcolor: "#1DA7A7",
          color: "white",
          fontSize: "1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Enter Your CIBIL Score</Typography>
        <Button
          size="medium"
          variant="text"
          startIcon={<ArrowBack />}
          sx={{ color: "white", fontWeight: "bold" }}
          onClick={() => navigate("/")}
        >
          Back
        </Button>
      </DialogTitle>

      <DialogContent sx={{ py: 5 }}>
        <TextField
          sx={{ mt: 5 }}
          fullWidth
          type="number"
          label="CIBIL Score"
          placeholder="e.g., 700"
          value={cibilScoreInput}
          onChange={(e) => {
            setCibilScoreInput(e.target.value);
            setCibilError("");
          }}
          error={!!cibilError}
          helperText={cibilError || `Minimum required: ${minCIBIL}`}
          autoFocus
        />
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <PrimaryButtom text="Continue" onClick={onSubmit} />
      </DialogActions>
    </Dialog>
  );
}
